export const rechargeManagement = {
	title: "Gestion des soldes",
	titleWithPeriod: "Recharges des {{period}} derniers jours",
	titleWithoutPeriod: "Recharges",
	editButton: "Modifier les soldes sélectionnés",
	statusSelect: "Statut",
	statusPlaceholder: "Filtrer par statut",
	employeesSelect: "Employé qui a créé",
	employeesPlaceholder: "Filtrer par employé",
	clientSearch: "Document du client",
	clientPlaceholder: "Filtrer par client",
	period: "Période",
	editTitle_other: "Modification de {{value}} soldes",
	editTitle_one: "Modification du solde",
	save: "Enregistrer les modifications",
	validPlace: "Lieux où les soldes sont valides",
	validPlacePlaceholder:
		"Cliquez pour sélectionner des lieux. Tous les lieux précédemment valides perdront leur validité s'ils ne sont pas dans cette sélection, sauf le lieu où la recharge a été effectuée à l'origine",
	expirationDate: "Date d'expiration",
	valid: "Valide encore {{value}} jours",
	expireToday: "Expire aujourd'hui",
	expired: "Expiré il y a {{value}} jours",
	required: "Champ obligatoire",
	columns: {
		id: "ID",
		date: "Date de création",
		method: "méthode de paiement",
		author: "Employé qui a créé",
		user: "Client",
		totalValue: "Valeur",
		expiresAt: "Date d'expiration",
		validPlaces: "valide dans les lieux",
		status: "Statut",
		rechargeType: "Type",
		minimumConsumption: "Consommation minimale",
		bonus: "Bonus",
		recharge: "Recharge",
	},
	activeLabel: "Valide",
	expiredLabel: "Expiré",
	refundedLabel: "Remboursé",
	emptyTitle: "Aucun solde",
	emptySubtitle: "Aucun solde dans la période sélectionnée",
	warningMessage:
		"Cette recharge continuera à être utilisée <b>même si elle apparaît comme annulée dans l'historique</b> jusqu'à ce que le client soit ré-enregistré si elle est déjà dans son ZigTag.",
	hasBonusOrMinimumConsumptionPlaceIdsError:
		"Modification des lieux bloquée pour les bonus et la consommation minimale",
	hasBonusOrMinimumConsumptionexpiresAtError:
		"Pour la consommation minimale, modification uniquement pour les dates expirées",
	editAllButton: "Modifier tous les soldes",
	editAllMessage: "Êtes-vous sûr de vouloir modifier tous les soldes ?",
	editAllConfirm: "Oui, aller à la modification",
	order: "Trier",
	asc: "Plus ancien",
	desc: "Plus récent",
	availableBalanceLabel: "Solde disponible total",
	expiredBalanceLabel: "Solde expiré total",
};
